<template>
  <div class="enterprise-network_container">
    <div class="enterprise-network_container_title">
      <div class="enterprise-network_container_title__left">
        Support Document
      </div>
      <div
        class="enterprise-network_container_title__right"
        v-if="isShowFileDown"
        @click="handleDownloadTemplate"
      >
        Download templates
      </div>
    </div>
    <div class="enterprise-network_container_table">
      <el-table border :data="tableList">
        <el-table-column
          label="Items"
          prop="items"
          min-width="219"
          show-overflow-tooltip
        >
          <template v-slot:default="{ row }">
            <span
              :class="{
                'required-label': row.isRequired && isFileRequired
              }"
              >{{ row.items }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          label="File Type"
          prop="fileTips"
          min-width="713"
          show-overflow-tooltip
        />
        <el-table-column
          label="File Name"
          prop="fileName"
          min-width="298"
          show-overflow-tooltip
        >
          <template v-slot:default="{ row }">
            <template v-if="row.isUpLoad">
              <div class="form-container_table__upload">
                <el-progress
                  class="form-container_table__uploadLine"
                  :percentage="row.progress"
                  :stroke-width="2"
                  :show-text="false"
                />
                <img
                  src="@/assets/delete_circle.svg"
                  width="24"
                  height="24"
                  @click="cancelUpload(row)"
                  alt=""
                />
              </div>
            </template>
            <template v-else>
              <div v-if="row.fileName" class="file-name">
                <span
                  @click="handleOpenFile(row.fileId, row)"
                  class="file-name_desc"
                >
                  {{ row.fileName }}
                </span>
                <img
                  v-if="isSeniorEditor"
                  src="@/assets/delete_circle.svg"
                  width="24"
                  height="24"
                  @click="handleRemoveFile(row)"
                  alt=""
                />
              </div>
              <span v-else>
                -
              </span>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="Operation" fixed="right" min-width="120" v-if="isSeniorEditor">
          <template #default="{row}">
            <el-upload
              class="upload-demo"
              action=""
              name="file"
              :accept="row.canUploadType"
              :show-file-list="false"
              :http-request="fileInfo => uploadFile(fileInfo, row)"
            >
              <el-button type="text">Upload</el-button>
            </el-upload>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { getNum, saveFileInfo, uploadFile } from "../../../../utils/upload";
import { recordUserAction } from "@/utils/recordUserAction.js"
import Big from "big.js";
import {
  getFileBySingType,
  postOssUpload
} from "../../../../api/international";
import APIS from "../../../../api/fileAxios/fileAxios";
export default {
  name: "enterpriseNetworkSupportDocumentEdit",
  props: {
    country: {
      type: String,
      default: ""
    },
    partnerType: {
      type: String,
      default: ""
    },
    // 显示下载模板按钮
    isShowFileDown: {
      type: Boolean,
      default: false
    },
    // 是否高级编辑
    isSeniorEditor: {
      type: Boolean,
      default: false
    },
    // 附件是否必填 用于基础编辑时老数据的问题 默认必填
    isFileRequired: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      tableList: [
        {
          items: "Business License",
          fileType: "CERTIFICATE_LICENSE",
          fileTips:
            "Max file size: 50MB. Accepted formats: JPG, JPEG, PNG, PPT, DOC, DOCX, PDF, RAR, ZIP",
          canUploadType:
            ".jpg,.jpeg,.gif,.png,.bmp,.rar,.zip,.pptx,.ppt,.docx,.doc,.pdf",
          isRequired: false,
          fileName: "", // 文件名
          fileId: "", // 文件id
          isUpLoad: false, // 是否上传
          progress: 0, // 进度 上传完之后清空
          client: null // 取消上传可通过这个
        },
        {
          items: "Business Plan",
          fileType: "BUSINESS_PLAN",
          fileTips:
            "Max file size: 50MB. Accepted formats: JPG, JPEG, PNG, PPT, DOC, DOCX, PDF, RAR, ZIP",
          canUploadType:
            ".jpg,.jpeg,.gif,.png,.bmp,.rar,.zip,.pptx,.ppt,.docx,.doc,.pdf",
          isRequired: false,
          fileName: "",
          fileId: "",
          isUpLoad: false,
          progress: 0,
          client: null
        },
        {
          items: "Contract Agreement",
          fileType: "COOPERATION_PLAN",
          fileTips: "Max file size: 50MB. Accepted formats: JPG, JPEG, PNG, PPT, DOC, DOCX, PDF, RAR, ZIP",
          canUploadType: ".jpg,.jpeg,.gif,.png,.bmp,.rar,.zip,.pptx,.ppt,.docx,.doc,.pdf",
          isRequired: true,
          fileName: "",
          isUpLoad: false,
          progress: 0,
          fileId: "",
          client: null
        }
      ]
    };
  },
  methods: {
    getItemName(typeNumber) {
      switch (typeNumber) {
        case 11:
          return "Business License";
        case 12:
          return "Business Plan";
        case 10:
          return "Contract Agreement";
        case 3:
          return "Authorization Certificate";
        case 1:
          return "Type of Contract";
        default:
          return "-";
      }
    },
    async uploadFile({ file }, row) {
      if (file.size === 0) {
        this.$message.error({
          message: "The file size upon upload is zero.",
          type: "warning"
        });
        return;
      }
      if (file.size > 52428800) {
        this.$message.error({
          message: "Error: File size exceeds the limit",
          type: "warning"
        });
        return;
      }
      // 保存文件的信息
      let saveFileParams = {};
      const uploadParams = {
        file,
        config: {
          originalFilename: file.name,
          contentType: file.type,
          service: "customer",
          module: row.fileType,
          userId: this.$store.state.user.userId,
          privateBucket: true
        },
        onProgress: p => {
          row.progress = getNum(
            Big(getNum(p))
              .times(100)
              .toFixed(2)
          );
        },
        cancel: client => {
          row.client = client;
        }
      };
      // 开启上传
      row.isUpLoad = true;
      try {
        const { res, name } = await uploadFile(uploadParams);
        if (res.status === 200) {
          saveFileParams = {
            service: "customer",
            size: file.size,
            objectName: name,
            module: row.fileType,
            userId: this.$store.state.user.userId,
            contentType: file.type,
            originalFilename: file.name,
            privateBucket: true
          };
          const { status, data } = await saveFileInfo(saveFileParams);
          if (status === "200") {
            const uploadParam = {
              type: row.fileType,
              fileId: data.id,
              fileName: data.name,
              downloadUrl: data.path
            };
            postOssUpload(uploadParam).then(res => {
              if (res.data) {
                // 存id
                row.fileId = res.data;
                row.fileName = data.name;
                row.isUpLoad = false;
                row.progress = 0;
                row.client = null;
              }
            });
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    cancelUpload(row) {
      row.client.cancel();
      row.client = null;
      row.progress = 0;
      row.isUpLoad = false;
      row.fileName = "";
    },
    handleRemoveFile(row) {
      row.fileId = "";
      row.fileName = "";
    },
    handleOpenFile(fileId, row) {
      if(row.typeNumber === 3){
        recordUserAction('electro_auth_download_event')
      }
      APIS.getAliOSSDownloadInfo(fileId)
        .then(res => {
          let { status, data } = res.data;
          if (Number(status) === 200) {
            window.open(data.fileInfo.url);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    handleDownloadTemplate() {
      const params = {
        countryCode: this.country,
        signType: this.partnerType
      };
      getFileBySingType(params)
        .then(res => {
          let { status, data } = res;
          if (Number(status) === 200) {
            if (data) {
              this.handleOpenFile(data);
            } else {
              this.$message.error(
                "Contract templates are not available for the current authorized region"
              );
            }
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    getFormData() {
      let isPass = true;
      this.tableList.forEach(item => {
        if (item.isRequired) {
          // 是否上传了文件
          isPass = !!item.fileId;
        }
      });
      // 如果不通过 还需判断附件是否必填
      if (!isPass && this.isFileRequired) {
        this.$message.error("please upload contract agreement");
        return false;
      }
      return {
        // 营业执照副本
        certificateLicenseUrl: this.tableList[0].fileId,
        // 业务规划书
        businessPlanUrl: this.tableList[1].fileId,
        // 合作协议书
        cooperationPlanUrl: this.tableList[2].fileId
      };
    },
    setFormData(fileList) {
      if (!fileList) return;
      fileList.forEach(item => {
        // 排除掉授权书 不允许修改
        const tableItem = this.tableList.find(
          tableItem => tableItem.items === this.getItemName(item.objectType)
        );
        if (tableItem) {
          tableItem.fileId = item.attachmentUrl;
          tableItem.fileName = item.name;
        }
      });
    }
  }
};
</script>

<style scoped>
.form-container_table__upload {
  display: flex;
  padding-top: 8px;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.form-container_table__upload .form-container_table__uploadLine {
  flex: 1;
}

.file-name {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
}

.file-name .file-name_desc {
  width: auto;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #2a82e4;
  cursor: pointer;
}

.required-label {
  position: relative;
}

.required-label:before {
  position: absolute;
  content: "*";
  color: #e60039;
  font-size: 14px;
  left: -10px;
  top: -8px;
}

.click-span {
  color: #2a82e4;
  cursor: pointer;
}

.enterprise-network_container_title__right {
  color: #2a82e4 !important;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/enterpriseNetwork/components/supportDocument/supportDocumentEdit.vue